Ext.define('SA.view.RingStudyGrid', {
    alias: 'widget.ring-study-grid',
    extend: 'SA.view.ReportGrid',

    listeners: {
        'cell:click': function(grid, td, data, column) {
            var location = column.dataIndex,
                variable = data.id;

            if (location === 'name') {
                grid.showRowMenu(td, variable);
            }
        },

        'cell:mouseout': function(grid, td, data, column) {
            var location = column.dataIndex;

            if (location === 'name') {
                Ext.fly(td).removeCls('sa-grid-cell-over');
            }
        },

        'cell:mouseover': function(grid, td, data, column) {
            var location = column.dataIndex;

            if (location === 'name') {
                Ext.fly(td).addCls('sa-grid-cell-over');
            }
        },

        'column:click': function(grid, el, column) {
            grid.showColumnMenu(el, column.dataIndex);
        },

        'column:mouseout': function(grid, td) {
            Ext.fly(td).removeCls('sa-grid-cell-over');
        },

        'column:mouseover': function(grid, td) {
            Ext.fly(td).addCls('sa-grid-cell-over');
        }
    },

    initComponent() {
        var reportModel = this.projectView;

        this.columns = this.buildColumns();
        this.data = [];

        this.callParent();

        this.refreshData();

        this.mon(reportModel, {
            buffer: 10,
            scope: this,

            'change:attribute': this.onChangeAttributes,
            'change:location': this.onChangeLocations
        });
    },

    plugins: [{
        ptype: 'sa-grid-row-drag-reorder',

        afterRowMove(data, offset) {
            var grid = this.cmp,
                report = grid.projectView,
                attribute = data.id,
                attributes = report.getAttributes(),
                index = attributes.indexOf(attribute);

            report.moveAttribute(index, index + offset);

            report.save();
        }
    }],

    buildColumns() {
        var reportModel = this.projectView,
            locations = reportModel.getQueryLocations(),
            country = SA.Institution.getCountry(reportModel.getCountry()),
            countryName = country.getName(),
            metersPerUnit = country.getMetersPerRadiusUnit(),
            unitName = country.isUSA() ? 'mile' : 'km',
            columns = [{
                cellCls: 'sa-report-grid-row-header',
                dataIndex: 'name',
                encodeCells: false,
                forceRender: true,
                text: '',
                width: 200
            }];

        locations.forEach(location => {
            var radius = location.radius;

            columns.push({
                align: 'right',
                autoWidth: true,
                contentWidth: true,
                dataIndex: location.id,
                text: radius ? Math.round(radius / metersPerUnit) + ' ' + unitName + ' radius' : 'All of ' + countryName
            });
        });

        return columns;
    },

    onChangeAttributes() {
        this.refreshData();
        this.refreshColumns();
    },

    onChangeLocations() {
        this.refreshColumns();
        this.refreshData();
    },

    refreshColumns() {
        this.setColumns(this.buildColumns());
    },

    refreshData() {
        var oldData = this.data,
            reportModel = this.projectView,
            dataMap = reportModel.getReportData({fn: this.refreshData, scope: this}),
            attributeIds = reportModel.getAttributes(),
            attributes = SA.data.AttributesCache.get(attributeIds),
            locations = reportModel.getQueryLocations(),
            rowsMap = {},
            data = [],
            hasData = false,
            isLoading = false;

        oldData.forEach(row => {
            rowsMap[row.id] = row;
        });

        attributes.forEach((attribute, index) => {
            var attributeId = attributeIds[index],
                row = rowsMap[attributeId],
                format = attribute.formatString;

            if (!row) {
                row = {id: attributeId};
            }

            row.name = this.getHeaderHtmlForAttribute(attribute);

            locations.forEach(location => {
                var locationId = location.id,
                    value = dataMap[locationId][attributeId];

                if (typeof value !== 'undefined') {
                    value = SA.data.AttributesCache.formatValue(value, format);
                    hasData = true;
                }
                else {
                    isLoading = true;
                }

                row[locationId] = value || '';
            });

            data.push(row);
        });

        this.isLoading = isLoading;

        this.setData(data);
        this.setLoading(isLoading && !hasData);

        this.ifCls(isLoading && hasData, 'sa-report-grid-empty-cell-loading');
    },

    showColumnMenu(el, locationSeries) {
        var grid = this,
            defaults = {location: locationSeries},
            items = [
                {
                    disabled: grid.isLoading,
                    text: locationSeries === 'name' ? 'Sort names A-Z' : 'Sort, smallest to largest',

                    handler() {
                        grid.sort(locationSeries, 'asc');
                    }
                }, {
                    disabled: grid.isLoading,
                    text: locationSeries === 'name' ? 'Sort names Z-A' : 'Sort, largest to smallest',

                    handler() {
                        grid.sort(locationSeries, 'desc');
                    }
                }
            ];

        grid.showMenu({el, items, defaults, includeHeader: false});
    },

    showRowMenu(el, attributeId) {
        var defaults = {attribute: attributeId},
            items = [
                {
                    xtype: 'menu-add-remove-favorite-attribute'
                }, {
                    xtype: 'menu-view-attribute-metadata'
                }, {
                    xtype: 'menu-open-data-folder'
                }, {
                    xtype: 'add-other-years-menu-item',
                    model: this.projectView
                }, {
                    xtype: 'add-count-or-percent-menu-item',
                    model: this.projectView
                }, {
                    xtype: 'menu-remove-attribute'
                }
            ];

        this.showMenu({el, items, defaults, includeHeader: false});
    },

    sort(locationId, direction) {
        var reportModel = this.projectView,
            dataMap = reportModel.getReportData(),
            values;

        if (locationId !== 'name') {
            values = dataMap[locationId];
        }

        reportModel.sortAttributes(SA.data.Sort.createAttributeSorter(values, direction));

        reportModel.save();
    }
});